import { LOGIN_VISIBILITY_CHANGED } from '../../../../actions/user';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { LoginState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/login';

const INITIAL_STATE: LoginState = {
  isOpen: false,
  referrer: null,
};

const login = (state: LoginState = INITIAL_STATE, action: Action): LoginState => {
  switch (action.type) {
    case LOGIN_VISIBILITY_CHANGED:
      return { ...state, isOpen: action.payload.visible, referrer: action.payload.referrer };
    default:
      return state;
  }
};

export default login;
export const get = (state: LoginState): LoginState => state;
